import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';

// Layout
import Layout from './components/Layout/Layout';

// Pages
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Devices from './pages/Devices/Devices';
import DeviceDetail from './pages/Devices/DeviceDetail';
import Users from './pages/Users/Users';
import UserProfile from './pages/Users/UserProfile';
import Profile from './pages/Profile/Profile';
import Customers from './pages/Customers/Customers';
import CustomerProfile from './pages/Customers/CustomerProfile';
import Firmware from './pages/Firmware/Firmware';
import Settings from './pages/Settings/Settings';
import Billing from './pages/Billing/Billing';
import InvoiceDetail from './pages/Billing/InvoiceDetail';
import CreateInvoice from './pages/Billing/CreateInvoice';
import EditInvoice from './pages/Billing/EditInvoice';
import DeviceRentals from './pages/Rentals/DeviceRentals';
import DeviceLogs from './pages/Logs/DeviceLogs';
import ApplicationLogs from './pages/Logs/ApplicationLogs';
import Telemetry from './pages/Telemetry';
import MQTTControl from './pages/MQTTControl';
import MonitoringDashboard from './pages/Monitoring/Dashboard';
import UserInfo from './pages/Debug/UserInfo';

// Context
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';

// Protected Route Component
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

function App() {
  return (
    <ConfigProvider>
      <PermissionProvider>
        <AuthProvider>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
              }}
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="devices" element={<ProtectedRoute><Devices /></ProtectedRoute>} />
                  <Route path="devices/:id" element={<ProtectedRoute><DeviceDetail /></ProtectedRoute>} />
                  <Route path="users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                  <Route path="users/:id" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
                  <Route path="customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
                  <Route path="customers/:id" element={<ProtectedRoute><CustomerProfile /></ProtectedRoute>} />
                  <Route path="billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
                  <Route path="billing/create" element={<ProtectedRoute><CreateInvoice /></ProtectedRoute>} />
                  <Route path="billing/:id" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
                  <Route path="billing/edit/:id" element={<ProtectedRoute><EditInvoice /></ProtectedRoute>} />
                  <Route path="rentals" element={<ProtectedRoute><DeviceRentals /></ProtectedRoute>} />
                  <Route path="firmware" element={<ProtectedRoute><Firmware /></ProtectedRoute>} />
                  <Route path="logs/device" element={<ProtectedRoute><DeviceLogs /></ProtectedRoute>} />
                  <Route path="logs/application" element={<ProtectedRoute><ApplicationLogs /></ProtectedRoute>} />
                  <Route path="telemetry" element={<ProtectedRoute><Telemetry /></ProtectedRoute>} />
                  <Route path="mqtt/control" element={<ProtectedRoute><MQTTControl /></ProtectedRoute>} />
                  <Route path="monitoring/dashboard" element={<ProtectedRoute><MonitoringDashboard /></ProtectedRoute>} />
                  <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                  <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="debug/user" element={<ProtectedRoute><UserInfo /></ProtectedRoute>} />
                </Route>
              </Routes>
            </Router>
        </AuthProvider>
      </PermissionProvider>
    </ConfigProvider>
  );
}

export default App;
